import React, { useState } from "react";
import {
  Filter,
  List as BaseList,
  Datagrid,
  TextField,
  DateField,
  BooleanField,
  TopToolbar,
  FilterButton,
  CreateButton,
  useListContext,
} from "react-admin";
import RegexSearchInput from "../../components/RegexSearchInput";
import ExportButton from "../../components/ExcelExportButton";
import { Box, Button, CircularProgress, Dialog, DialogContent, Typography } from "@mui/material";
import useExport from "../../components/UseExcelExport";
import { useGetOne, useGetList } from "react-admin";
import UpgradePlanModal from "../../components/UpgradePlanModal";
import AddIcon from "@mui/icons-material/Add";

const NameFilter = [<RegexSearchInput source="name" label="Nombre" />];

const ListActions = ({ canCreate, className, basePath, plan }) => {
  const { getExportData, exportData, setExportData } = useExport("enterprise/branches");
  const [openModal, setOpenModal] = useState(false);
  const { filterValues } = useListContext();
  const [openUpgradeModal, setOpenUpgradeModal] = useState(false);
  const handleExportClick = async () => {
    if (!exportData.length) {
      setOpenModal(true);
      await getExportData(filterValues);
      setOpenModal(false);
    }
  };
  const handleClearData = () => {
    setExportData([]);
  };
  console.log("PLAN", plan);
  const handleClick = () => {
    if (plan !== "franquicia" && plan !== "enterprise") {
      setOpenUpgradeModal(true);
      return;
    }
  };
  const columns = [
    { label: "Nombre", source: "name" },
    { label: "Teléfono", source: "addressInfo.phone" },
    { label: "Dirección", source: "addressInfo.street" },
    { label: "Estado", source: "status", transform: (value) => (value ? "habilitado" : "no habilitado") },
  ];

  return (
    <TopToolbar
      className={className}
      style={{
        display: "flex",
        // justifyContent: "space-between",
        alignItems: "center",
        padding: "0 16px",
        marginBottom: "0",
      }}
    >
      <div style={{ display: "flex", gap: "16px" }}>
        <FilterButton filters={NameFilter} />
        {canCreate ? (
          <CreateButton basePath={basePath} />
        ) : (
          <Button
            onClick={handleClick}
            startIcon={<AddIcon />}
            sx={{
              color: "#ff770d", // color primario personalizado
              fontWeight: 500,
              textTransform: "none",
              background: "none",
              boxShadow: "none",
              "&:hover": {
                backgroundColor: "rgba(255, 119, 13, 0.08)", // mismo color pero con transparencia al hacer hover
                boxShadow: "none",
              },
            }}
          >
            CREAR
          </Button>
        )}
      </div>
      <ExportButton
        onClick={handleExportClick}
        data={exportData}
        columns={columns}
        filename="branches.xlsx"
        clearData={handleClearData}
      />
      <Dialog open={openModal} onClose={() => setOpenModal(false)}>
        <DialogContent>
          <Box display="flex" flexDirection="column" alignItems="center">
            <CircularProgress />
            <Typography variant="body1" style={{ marginTop: 16 }}>
              Cargando datos para exportación...
            </Typography>
          </Box>
        </DialogContent>
      </Dialog>
      <UpgradePlanModal
        open={openUpgradeModal}
        onClose={() => setOpenUpgradeModal(false)}
        planActual={plan}
        planDestino="franquicia"
      />
    </TopToolbar>
  );
};

export const List = (props) => {
  const [openUpgradeModal, setOpenUpgradeModal] = useState(false);
  const profile = JSON.parse(localStorage.getItem("profile"));
  const providerId = profile?.role === "admin-sucursal" ? profile?.employer?._id : profile?._id;

  const { data: provider } = useGetOne("providers", { id: providerId });
  const { data: branches = [] } = useGetList("enterprise/branches", {
    filter: { status: true },
    pagination: { page: 1, perPage: 100 },
    sort: { field: "name", order: "ASC" },
  });

  const plan = provider?.plan;
  const branchCount = branches?.length || 0;

  const canCreate = plan === "franquicia" || plan === "enterprise" || branchCount === 0;
  return (
    <>
      <BaseList
        {...props}
        filters={NameFilter}
        bulkActionButtons={false}
        actions={<ListActions canCreate={canCreate} basePath={props.basePath} plan={plan} />}
      >
        {(plan === "freemium" || plan === "standard") && (
          <Box
            sx={{
              position: "sticky",
              top: 0,
              zIndex: 5,
              background: "#fffaf3",
              borderBottom: "1px solid #ffe0c1",
              py: 1,
              px: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="body2" sx={{ color: "#7a5400", fontWeight: 500 }}>
              Estás usando el plan <b>{provider?.plan}</b>. La gestión completa de sucursales está disponible en el
              plan&nbsp;
              <b>Franquicia</b>.
            </Typography>
            <Button
              size="small"
              variant="contained"
              onClick={() => setOpenUpgradeModal(true)}
              sx={{
                backgroundColor: "#FF770D",
                "&:hover": { backgroundColor: "#e65e00" },
                textTransform: "none",
                color: "#fff",
              }}
            >
              Conocer beneficios
            </Button>
          </Box>
        )}
        <Datagrid rowClick="edit" bulkActionButtons={false}>
          <TextField source="name" label="Nombre" />
          <TextField source="addressInfo.phone" label="Teléfono" />
          <TextField source="addressInfo.street" label="Dirección" />
          <BooleanField source="status" label="Estado" />
        </Datagrid>
      </BaseList>
      <UpgradePlanModal
        open={openUpgradeModal}
        onClose={() => setOpenUpgradeModal(false)}
        planActual={plan}
        planDestino="franquicia"
      />
    </>
  );
};
